import { createFactory } from 'react'

import Fearless from 'clients/Fearless'
import Clockbeats from 'clients/Clockbeats'
import NextGeneration from 'clients/NextGeneration'
import ClockbeatsOrchestra from 'clients/ClockbeatsOrchestra'
import RedTheater from 'clients/RedTheater'
import Prova from 'clients/Prova.html' 
import Parser from 'html-react-parser'


export default [
  {
    description:
      'Clockbeats is the first community specifically designed for professionals and amateurs working in the music industry.',
    duration: '2016 - Present',
    name: 'Clockbeats',
    logo: require('img/clockbeats/clockbeats_logo.svg'),
    loadComponent: createFactory(Clockbeats),
    order: 0,
    properties: null,
    slug: 'clockbeats',
    role: 'Director - Founder',
    website: 'https://clockbeats.com',
    type: 'Film & Web Platform',
    location: 'Italy',
    blog: 'https://blog.clockbeats.com' 
  },
  {
    description:
      'Humanity is purposed with the day, and with each day lies the potential for greatness.',
    duration: '2017',
    name: 'FEARLESS',
    // location: '',
    logo: require('img/fearless/clockbeats_logo.svg'),
    loadComponent: createFactory(Fearless),
    order: 1,
    properties: { className: 'white' },
    slug: 'fearless',
    role: 'Sound Designer',
    video: 'https://vimeo.com/235339103',
    type: 'Film'
  },
  {
    description:
      'Next Generation is my debut single on Rebirth Records',
    duration: '2017',
    name: 'Next Generation',
    location: 'Brescia, Italy',
    logo: require('img/next-generation/rebirth_logo.png'),
    loadComponent: createFactory(NextGeneration),
    order: 2,
    properties: null,
    slug: 'next-generation',
    role: 'Producer',
    website: 'https://www.beatport.com/release/next-generation/2073349',
    type: 'Audio',
    label: { name: 'Rebirth', url: 'http://rebirth.dj/' },
    logoRaster: true,
  },
  {
    description:
      'It’s an Orchestra, a coordinated combination of sounds, instruments, artists. People bringing to life many sequences of sounds: melodies and harmonies created by the di erent instruments of which it is comprised: this is how so-called symphonic music is born.',
    duration: '2015-Present',
    name: 'Clockbeats Orchestra',
    location: 'Chapel Hill, NC',
    logo: require('img/clockbeats-orchestra/cb_orchestra_logo.png'),
    logoRaster: true,
    loadComponent: createFactory(ClockbeatsOrchestra),
    order: 3,
    properties: null,
    slug: 'clockbeats-orchestra',
    // playstore: '',
    role: 'President',
    website: 'https://clockbeatsorchestra.com/',
    type: 'Live Performance'
  },
  {
    description: 'RedTheater is a project created by a group of friends who loves music, theater and visual arts.',
    duration: '2016-Present',
    name: 'Red Theater - Performing Arts Factory',
    order: 4,
    logoRaster: true,
    properties: null,
    slug: 'red-theater',
    logo: require('img/red-theater/logo.png'),
    role: 'Organizator',
    website: 'http://www.redtheater.it/en/',
    loadComponent: createFactory(RedTheater),
    type: 'Live Performance',
  },
  // {
  //   description:
  //     'Estroso, unico, Charlie Goes to Paradise è l’innovativo progetto nato dalla collaborazione fra Paolo Mantini e Alessandro Costantini, giovani e talentuosi musicisti bresciani da sempre legati da una profonda amicizia. ',
  //   duration: '2015-2017',
  //   name: 'TEDx Charlie goes to Paradise',
  //   location: 'Wilmington, NC',
  //   logo: require('img/tedx/logo.svg'),
  //   loadComponent: createFactory(Likeli),
  //   order: 4,
  //   properties: null,
  //   slug: 'tedx',
  //   role: 'Musician',
  //   website: '',
  //   type: 'Live Show'
  // },
  // client: {
  //   description: '',
  //   duration: '',
  //   name: '',
  //   order: '',
  //   properties: null,
  //   slug: '',
  //   appstore: '',
  //   playstore: '',
  //   role: '',
  //   scope: '',
  //   stack: '',
  //   website: '',
  // },
]

export const moreWork = [
  {
    img: 'apical',
    // href: 'http://gener8tor.com',
  },
  {
    img: 'art_of_fighters',
    // href: 'https://optyn.com/',
  },
  {
    img: 'benelli',
    // href: 'http://wemontage.com',
  },
  {
    img: 'claudio_coccoluto',
    // href: 'http://beekeeperdata.com',
  },
  {
    img: 'clique',
    // href: 'https://angel.co/taplet-1',
  },
  {
    img: 'disco_volante',
    // href: '',
  },
  {
    img: 'ed3sign',
    // href: '',
  },
  {
    img: 'flash_factory',
    // href: '',
  },
  {
    img: 'funkyou',
    // href: '',
  },
  {
    img: 'g',
    // href: '',
  },
  {
    img: 'ghisleri',
    // href: '',
  },
  {
    img: 'keepon_live',
    // href: '',
  },
  {
    img: 'kickstarter',
    // href: '',
  },
  {
    img: 'nekt_project',
    // href: '',
  },
  {
    img: 'ogopogo',
    // href: '',
  },
  {
    img: 'persistence_label',
    // href: '',
  },
  {
    img: 'rebirth',
    // href: '',
  },
  {
    img: 'red_theatre',
    // href: '',
  },
  {
    img: 'remic',
    // href: '',
  },
  {
    img: 'ren',
    // href: '',
  },
  {
    img: 'rob_ricotta',
    // href: '',
  },
  {
    img: 'smider',
    // href: '',
  },
  {
    img: 'sonntag_morgen_records',
    // href: '',
  },
  {
    img: 'virgo',
    // href: '',
  },
]



// WEBPACK FOOTER //
// src/javascripts/utils/clients.js